import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 17}
        height={props.height ?? 16}
        fill="none"
        {...props}
    >
        <Path
            fill={props.color ?? ds.colorValue.icon.primary}
            d="m3.792 5.918-.53.53 3.83 3.83.53-.53.53-.53-3.83-3.83-.53.53Zm5.598 3.83.53.53 3.83-3.83-.53-.53-.53-.53-3.83 3.83.53.53Zm-1.768 0-.53.53a2 2 0 0 0 2.828 0l-.53-.53-.53-.53a.5.5 0 0 1-.708 0l-.53.53Z"
        />
    </Svg>
);

export { SvgComponent as ArrowDownThin };
